import React from 'react';

const Disclaimer = () => {
  return (
    <p style={{ fontSize: 10, textAlign: 'center' }}>
      {
        'Airacer is an air charter broker and is not a direct air carrier or foreign air carrier in operational control of aircraft. All advertised air service shall be provided by a properly licensed direct air carrier or foreign direct air carrier.'
      }
    </p>
  );
};

export default Disclaimer;
